<div id="PG_LIXISubmissionSummary" class="glb_formBGColor glb_boxedPadding glb_Font text-white glb_Font">
    <div class="glb_Font header-padding glb_customFlexRow">
        <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
            <div class="col-12 glb_customFlexRow glb_paddingBottomMD align-items-center glb_paddingZeroOffset">
                <div class="glb_TitleLG glb_TitleLGMobile text-start glb_fontColorSkin glb_breakLongWords glb_paddingZeroOffset col-12">
                    Recent LIXI Submissions
                </div>
            </div>
        </div>
        <br>
        <div class="col-md-12 col-lg-12">
            <div class="glb_forceMarginAuto glb_customFlexRow justify-content-between align-items-center glb_paddingBottomXS">
                <!-- Left side with filter box and clear button -->
                <div class="glb_customFlexRow col-md-6 col-lg-6 justify-content-start align-items-center">
                    <div class="glb_customFlexRow justify-content-start align-items-center col-10">
                        <!-- Filter input box -->
                        <input class="glb_formInputBoxDark glb_skinLightOutline glb_Font text-white" [(ngModel)]="SearchText" cdkFocusInitial
                            tabindex="1" type="name" placeholder="Filter" (input)="LIXISubmissions_Filter($event)" style="min-width: 200px;">
                    </div>
                    <div class="glb_customFlexRow justify-content-start align-items-center col-2">
                        <span style="padding-left:0.375em;">
                            <button
                                class="glb_clickableIconButtonStyle glb_clickableIconButtonColorDark glb_clickableIconButtonMD btn-secondary align-self-center"
                                (click)="Filter_Clear()">
                                <fa-icon class="fa-fw glb_fixedSizeIcons" [icon]="['fal', 'eraser']" matTooltip="Clear search filter">
                                </fa-icon>
                            </button>
                        </span>
                    </div>
                </div>

                <!-- Right side with download and refresh buttons -->
                <div class="glb_customFlexRow col-md-6 col-lg-6 justify-content-end align-items-center">
                    <div *ngIf="!IsGenerateInProgress && FilteredSubmissions.length > 0" class="glb_rightAlignedContentPadding">
                        <button id="BTN_DownloadLIXISubmissions"
                            class="glb_clickableIconButtonStyle glb_clickableIconButtonColorDark glb_clickableIconButtonMD btn-secondary align-self-center"
                            (click)="LIXISubmissions_DownloadCSV()">
                            <fa-icon [icon]="['fal', 'download']" class="fa-fw glb_fixedSizeIcons" matTooltip="Click to Download">
                            </fa-icon>
                        </button>
                    </div>
                    <div *ngIf="!IsGenerateInProgress" class="glb_rightAlignedContentPadding">
                        <button tabindex="2"
                            class="glb_clickableIconButtonStyle glb_clickableIconButtonColorDark glb_clickableIconButtonMD btn-secondary align-self-center"
                            (click)="LIXISubmissions_Refresh()">
                            <fa-icon [icon]="['fal', 'sync-alt']" class="fa-fw glb_fixedSizeIcons" matTooltip="Click to Refresh">
                            </fa-icon>
                        </button>
                    </div>
                    <div *ngIf="IsGenerateInProgress" class="glb_rightAlignedContentPadding">
                        <button
                            class="glb_clickableIconButtonStyle glb_clickableIconButtonColorDark glb_clickableIconButtonMD btn-secondary align-self-center">
                            <fa-icon [icon]="['fal', 'compact-disc']" class="fa-fw glb_fastSpin glb_fixedSizeIcons"
                                matTooltip="Loading...Please wait"></fa-icon>
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-12">
            <div class="glb_allBordersGreyRoundedSM glb_Font col-12 glb_customFlexRow glb_PaddingHorizontalMD">
                <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
                    <div
                        class="glb_thinBottomWhiteBorder glb_LabelFontDarkTitle glb_customFlexRow col-12 glb_paddingZeroOffset row-cols-9 headerStyle glb_paddingTopSM glb_paddingBottomSM">
                        <div class="col-2 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Originator Ref No</div>
                            <fa-icon *ngIf="HeaderColumns[0].SortKey > 0 && HeaderColumns[0].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('OriginatorRef')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[0].SortKey > 0 && HeaderColumns[0].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('OriginatorRef')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[0].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('OriginatorRef')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[0].SortKey > 0">{{HeaderColumns[0].SortKey}}</span>
                        </div>
                        <div class="col-2 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Lender</div>
                            <fa-icon *ngIf="HeaderColumns[1].SortKey > 0 && HeaderColumns[1].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Lender')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[1].SortKey > 0 && HeaderColumns[1].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Lender')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[1].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('Lender')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[1].SortKey > 0">{{HeaderColumns[1].SortKey}}</span>
                        </div>
                        <div class="col-1 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Lodged Date</div>
                            <fa-icon *ngIf="HeaderColumns[2].SortKey > 0 && HeaderColumns[2].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('LodgedDate')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[2].SortKey > 0 && HeaderColumns[2].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('LodgedDate')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[2].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('LodgedDate')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[2].SortKey > 0">{{HeaderColumns[2].SortKey}}</span>
                        </div>
                        <div class="col-1 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Loan Numbers</div>
                            <fa-icon *ngIf="HeaderColumns[3].SortKey > 0 && HeaderColumns[3].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('LoanNumbers')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[3].SortKey > 0 && HeaderColumns[3].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('LoanNumbers')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[3].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('LoanNumbers')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[3].SortKey > 0">{{HeaderColumns[3].SortKey}}</span>
                        </div>
                        <div class="col-2 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Principal Borrower</div>
                            <fa-icon *ngIf="HeaderColumns[4].SortKey > 0 && HeaderColumns[4].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('PrincipalBorrower')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[4].SortKey > 0 && HeaderColumns[4].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('PrincipalBorrower')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[4].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('PrincipalBorrower')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[4].SortKey > 0">{{HeaderColumns[4].SortKey}}</span>
                        </div>
                        <div class="col-1 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Status</div>
                            <fa-icon *ngIf="HeaderColumns[5].SortKey > 0 && HeaderColumns[5].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Status')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[5].SortKey > 0 && HeaderColumns[5].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Status')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[5].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('Status')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[5].SortKey > 0">{{HeaderColumns[5].SortKey}}</span>
                        </div>
                        <div class="col-1 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Errors</div>
                            <fa-icon *ngIf="HeaderColumns[6].SortKey > 0 && HeaderColumns[6].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Errors')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[6].SortKey > 0 && HeaderColumns[6].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Errors')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[6].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('Errors')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[6].SortKey > 0">{{HeaderColumns[6].SortKey}}</span>
                        </div>
                        <div class="col-1 glb_customFlexRow align-items-center">
                            <div style="padding-right: 5px;">Warnings</div>
                            <fa-icon *ngIf="HeaderColumns[7].SortKey > 0 && HeaderColumns[7].SortDirection === 1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-short-wide']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Warnings')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[7].SortKey > 0 && HeaderColumns[7].SortDirection === -1" class="fa-fw glb_hoverHand"
                                [icon]="['fal', 'arrow-down-wide-short']" matTooltip="Click to Sort" matTooltipPosition="right"
                                (click)="Click_Sort('Warnings')">
                            </fa-icon>
                            <fa-icon *ngIf="HeaderColumns[7].SortKey === 0" class="fa-fw glb_hoverHand" [icon]="['fal', 'sort']"
                                matTooltip="Click to Sort" matTooltipPosition="right" (click)="Click_Sort('Warnings')">
                            </fa-icon>
                            <span *ngIf="HeaderColumns[7].SortKey > 0">{{HeaderColumns[7].SortKey}}</span>
                        </div>
                        <div class="col-1 glb_customFlexRow align-items-center justify-content-center">
                            <div>View Document</div>
                        </div>
                    </div>
                    <div class="glb_customFlexRow col-12 glb_paddingZeroOffset">
                        <div class="col-12 glb_minHeight300 glb_maxHeight800" style="overflow-y:auto; overflow-x:hidden; overflow-wrap: normal;">
                            <!-- Loop through submissions to display them -->
                            <div class="glb_thinBottomWhiteBorder glb_XSPaddingBottomSM glb_XSPaddingTopSM glb_customFlexRow col-12 glb_PaddingVerticalSM row-cols-9"
                                *ngFor="let submission of FilteredSubmissions | paginate: {id: 'search', itemsPerPage: 9, currentPage:
                                CurrentPage}">

                                <!-- Originator Reference -->
                                <div class="col-2 glb_customFlexRow align-items-start glb_TextAlignMobileCentered">
                                    {{submission.OriginatorRef}}
                                </div>

                                <!-- Lender -->
                                <div class="col-2 glb_customFlexRow align-items-start glb_TextAlignMobileCentered" matTooltip="{{submission.Lender}}"
                                    matTooltipPosition="right">
                                    {{submission.LenderInternalName}}
                                </div>

                                <!-- Lodged Date -->
                                <div class=" col-1 glb_customFlexRow align-items-center glb_TextAlignMobileCentered  align-items-start">
                                    {{submission.LodgedDate}}
                                </div>

                                <!-- Loan Numbers -->
                                <div class="col-1 glb_customFlexRow align-items-center glb_TextAlignMobileCentered align-items-start">
                                    <ng-container *ngIf="submission.LoanNumbers && submission.LoanNumbers.length > 0">
                                        <ng-container *ngFor="let loanNumber of submission.LoanNumbers.split(','); let last = last">
                                            <ng-container *ngIf="CachedAccount_Has(submission, loanNumber.trim()); else noLink">
                                                <a href="javascript:void(0)" class="glb_fontColorSkin"
                                                    (click)="LoanNumber_Click(submission, loanNumber.trim())">{{loanNumber.trim()}}</a>
                                            </ng-container>
                                            <ng-template #noLink>
                                                <span>{{loanNumber.trim()}}</span>
                                            </ng-template>
                                            <span *ngIf="!last">, </span>
                                        </ng-container>
                                    </ng-container>
                                    <span *ngIf="!submission.LoanNumbers || submission.LoanNumbers.length === 0">-</span>
                                </div>

                                <!-- Principal Borrower -->
                                <div class="col-2 glb_customFlexRow align-items-center align-items-start glb_TextAlignMobileCentered"
                                    matTooltip="{{submission.PrincipalBorrower}}" matTooltipPosition="right"
                                    [matTooltipDisabled]="submission.DisableBorrowerToolTip">
                                    {{globalFunctions.LimitTextSize(submission.PrincipalBorrower,TextDisplayLimit)}}
                                </div>

                                <!-- Status -->
                                <div class="col-1 glb_customFlexRow align-items-center align-items-start glb_TextAlignMobileCentered"> <span
                                        [ngClass]="StatusCSS_Get(submission.Status)">{{submission.Status}}</span>
                                </div>

                                <!-- Errors -->
                                <div class="col-1 glb_customFlexRow align-items-center justify-content-start glb_TextAlignMobileCentered">
                                    <div class="col-10 glb_customFlexRow">
                                        {{globalFunctions.LimitTextSize(submission.Errors,TextDisplayLimit)}}
                                    </div>
                                    <div *ngIf="submission.Errors.length > 0" class="col-2 glb_customFlexRow">
                                        <button id="BTN_ShowErrorDetails" class="glb_clickableIconButtonMD align-self-right">
                                            <fa-icon [icon]="['fal', 'magnifying-glass']" class="fa-fw glb_fixedSizeIcons IconColorDark"
                                                matTooltip="View error details" matTooltipPosition="right"
                                                (click)="SubmissionDetails_View(submission,'Error')">
                                            </fa-icon>
                                        </button>
                                    </div>
                                </div>

                                <!-- Warnings -->
                                <div class="col-1 glb_customFlexRow align-items-center justify-content-start glb_TextAlignMobileCentered">
                                    <div class="col-10 glb_customFlexRow">
                                        {{globalFunctions.LimitTextSize(submission.Warnings,TextDisplayLimit)}}
                                    </div>
                                    <div *ngIf="submission.Warnings.length > 0" class="col-2 glb_customFlexRow">
                                        <button id="BTN_ShowErrorDetails" class="glb_clickableIconButtonMD align-self-right">
                                            <fa-icon [icon]="['fal', 'magnifying-glass']" class="fa-fw glb_fixedSizeIcons IconColorDark"
                                                matTooltip="View warning details" matTooltipPosition="right"
                                                (click)="SubmissionDetails_View(submission, 'Warning')">
                                            </fa-icon>
                                        </button>
                                    </div>
                                </div>

                                <!-- Action -->
                                <div class="col-1 glb_customFlexRow align-items-center justify-content-center glb_TextAlignMobileCentered">
                                    <div class="glb_customFlexRow">
                                        <button class=" glb_clickableIconButtonStyle glb_clickableIconButtonColorLight glb_clickableIconButtonMD"
                                            (click)="LIXIDocument_Get(submission)">
                                            <fa-icon [icon]="['fal', 'eye']" matTooltip="View LIXI file"></fa-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- No data message -->
                            <div *ngIf="!FilteredSubmissions || FilteredSubmissions.length === 0"
                                class="glb_customFlexRow col-12 justify-content-center glb_paddingTopMD glb_paddingBottomMD">
                                <div class="glb_Font">No submissions found</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="glb_customFlexRow col-12 row-cols-1 justify-content-center align-items-center glb_paddingBottomXS">
        <div class="col-12 glb_customFlexRow justify-content-center glb_Font">
            <pagination-controls class="glb_paginatorDark" id='search' (pageChange)="Page_OnChange($event)" [maxSize]="Paging.MaxSize"
                [responsive]="true" [previousLabel]="Paging.PreviousLabel" [nextLabel]="Paging.NextLabel">
            </pagination-controls>
        </div>
    </div>
</div>